var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2565 16.5938C3.13983 14.7098 2.74924 12.483 3.15804 10.3314C3.56684 8.17983 4.74693 6.25147 6.47677 4.90832C8.2066 3.56517 10.3672 2.89961 12.553 3.0366C14.7388 3.17358 16.7994 4.10368 18.348 5.65229C19.8966 7.20089 20.8267 9.26151 20.9637 11.4473C21.1007 13.6331 20.4351 15.7937 19.0919 17.5235C17.7488 19.2533 15.8204 20.4334 13.6689 20.8422C11.5173 21.251 9.29049 20.8604 7.4065 19.7438L4.294 20.625C4.16648 20.6623 4.03128 20.6646 3.90256 20.6317C3.77384 20.5988 3.65635 20.5318 3.5624 20.4379C3.46845 20.3439 3.4015 20.2264 3.36858 20.0977C3.33565 19.969 3.33796 19.8338 3.37525 19.7063L4.2565 16.5938Z",
    fill: "#147F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2565 16.5938C3.13983 14.7098 2.74924 12.483 3.15804 10.3314C3.56684 8.17983 4.74693 6.25146 6.47677 4.90832C8.2066 3.56517 10.3672 2.89961 12.553 3.0366C14.7388 3.17358 16.7994 4.10368 18.348 5.65229C19.8966 7.20089 20.8267 9.26151 20.9637 11.4473C21.1007 13.6331 20.4351 15.7937 19.0919 17.5235C17.7488 19.2533 15.8204 20.4334 13.6689 20.8422C11.5173 21.251 9.29049 20.8604 7.4065 19.7438L4.294 20.625C4.16648 20.6623 4.03128 20.6646 3.90256 20.6317C3.77384 20.5988 3.65635 20.5318 3.5624 20.4379C3.46845 20.3439 3.4015 20.2264 3.36858 20.0977C3.33565 19.969 3.33796 19.8338 3.37525 19.7063L4.2565 16.5938Z",
    stroke: "#147F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.125C12.6213 13.125 13.125 12.6213 13.125 12C13.125 11.3787 12.6213 10.875 12 10.875C11.3787 10.875 10.875 11.3787 10.875 12C10.875 12.6213 11.3787 13.125 12 13.125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.125C8.12132 13.125 8.625 12.6213 8.625 12C8.625 11.3787 8.12132 10.875 7.5 10.875C6.87868 10.875 6.375 11.3787 6.375 12C6.375 12.6213 6.87868 13.125 7.5 13.125Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.125C17.1213 13.125 17.625 12.6213 17.625 12C17.625 11.3787 17.1213 10.875 16.5 10.875C15.8787 10.875 15.375 11.3787 15.375 12C15.375 12.6213 15.8787 13.125 16.5 13.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveChat);
export default __webpack_public_path__ + "static/media/active_chat.32058207417c139385ab71d805b83e75.svg";
export { ForwardRef as ReactComponent };